import { render, staticRenderFns } from "./PrivacyPolicyBanner.vue?vue&type=template&id=1720965e"
import script from "./PrivacyPolicyBanner.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyBanner.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyBanner.vue?vue&type=style&index=0&id=1720965e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports